import './blog.scss';
class Blog {
    constructor (element) {
        this.$blog = element;
        this.$entriesWrapper = this.$blog.querySelector('[data-blog="entries"]');
        this.$$entries = this.$blog.querySelectorAll('[data-blog="entry"]');
    }

    initialize () {
        if (this.$$entries.length > 0 && this.$entriesWrapper) {
            window.setTimeout(() => {
                this.setHeight();
                this.setEvents();
            }, 150);
        }
    }

    // Sets container height to the height of the highest column
    setHeight () {
        this.$entriesWrapper = this.$blog.querySelector('[data-blog="entries"]');
        const columnCount = window.innerWidth >= 1024 ? 3 : window.innerWidth >= 768 ? 2 : 1;

        if (columnCount > 1) {
            const columns = [[], [], []];

            this.$$entries.forEach((entry, index) => {
                columns[index % columnCount].push(entry);
            });

            const maxHeight = Math.max(
                ...columns.map(column =>
                    column.reduce((acc, element) => acc + element.offsetHeight, 0) + 50 * column.length
                )
            );

            this.$entriesWrapper.style.setProperty('--max-height', `${maxHeight}px`);
        } else {
            this.$entriesWrapper.style.setProperty('--max-height', 'auto');
        }
    }

    setEvents () {
        let timeoutId;

        window.addEventListener('resize', () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }

            timeoutId = setTimeout(() => {
                this.setHeight();
            }, 150);
        });
    }
}

export { Blog };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $blog = $context.querySelectorAll('[data-blog="root"]');
        if ($blog.length > 0) {
            for (let i = 0; i < $blog.length; i++) {
                const blog = new Blog($blog[i]);
                blog.initialize();
            }
        }
    }
});
